import _remove from 'lodash/remove';
import addStudentTemplate from './../../settings/add-student/add-student.html';
import template from './add-happening.html';

class AddHappeningComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $state, moment,
    StudentService,
    HappeningService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.moment = moment;
    this.StudentService = StudentService;
    this.HappeningService = HappeningService;

    this.happening = {};
    this.selectedStudents = [];
    this.selectedStudentsIDs = [];
  }

  $onChanges(changes) {
    if (changes.students) {
      this.students = Object.assign([], this.students);
    }
  }

  addStudent(ev) {
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'AddStudentController',
      template: addStudentTemplate,
      clickOutsideToClose: true,
      locals: {students: this.students},
      targetEvent: ev
    })
      .then(result => {
        _remove(this.selectedStudents, student => student.id === result.id);
        this.selectedStudents.unshift(result);
        this.selectedStudentsIDs.push(Number(result.id));
      }, () => {});
  }

  removeStudent(studentToRemove) {
    _remove(this.selectedStudents, student => student.id === studentToRemove.id);
    _remove(this.selectedStudentsIDs, id => id === Number(studentToRemove.id));
    this.students.push(studentToRemove);
  }

  add(form) {
    if (form.$invalid) {
      return false;
    }

    this.happening.date = this.moment(this.date).format('YYYY-MM-DD');
    this.happening.students = this.selectedStudentsIDs;
    this.happening.studentObjects = this.selectedStudents;

    this.HappeningService.add(
      {
        data: this.happening,
        addToLocal: true
      }
    ).then(() => {
      this.$state.go('modules.happenings');
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Dodano wydarzenie')
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }
}

export const AddHappening = {
  bindings: {
    students: '<'
  },
  template,
  controller: AddHappeningComponent
};
